import { IContentStreamService, ContentStreamService } from "./contentstream";
import { ISectionService, SectionService } from "./section";
import { IViewerContentService, ViewerContentService } from "./viewercontent";
import { SyndicationArticleService, ISyndicationArticleService } from "./syndication";
import { IPublicationService, PublicationService } from "./publication";
import { IPdfContentService, PdfContentService } from "./issuecontent";
import { IIssueService, IssueService } from "./issue";
import { IDomainService, DomainService } from "./domain";
import { IContentStreamCurateService, ContentStreamCurateService } from "./contentstreamcurate";
import { IContentStreamIssueService, ContentStreamIssueService } from "./contentstreamissue";
import { IParticaStoreService, ParticaStoreService } from "./particastore";
import { IWordsmartService, WordsmartService } from "./wordsmart";
import { IArticleSearchService, ArticleSearchService } from "./articlesearch";
import { IViewerArticleService, ViewerArticleService } from "./viewerarticles";
import { IWrittenArticleService, WrittenArticleService } from "./writtenarticles";
import { INavigationService, NavigationService } from "@/NavigationServices/navigation";
import { IMetadataService, MetadataService } from "./metadataarticles";
import { IUserService, UserService } from "./user";
import { ContentStreamPaymentService, IContentStreamPaymentService } from "./contentstreampayment";
import { IIssueConversionService, IssueConversionService } from "./issueconversion";
import { IWebsiteUserService, WebsiteUserService } from "./websiteusers";
import { IWordpressPluginService, WordpressPluginService } from "./wpplugin";
import { IScheduledTaskService, ScheduledTaskService } from "./scheduledtask";
import { IArticleService, ArticleService } from "./article";
import { IArticleLicenceService, ArticleLicenceService } from "./accountlicence";

export interface IParticaServices {
	getContentStreamService(): IContentStreamService;
	getContentStreamIssueService(): IContentStreamIssueService;
	getContentStreamCurateService(): IContentStreamCurateService;
	getSectionService(): ISectionService;
	getViewerContentService(): IViewerContentService;
	getSyndicationArticleService(): ISyndicationArticleService;
	getPublicationService(): IPublicationService;
	getMetadataService(): IMetadataService;
	getPdfContentService(): IPdfContentService;
	getIssueService(): IIssueService;
	getDomainService(): IDomainService;
	getParticaStoreService(): IParticaStoreService;
	getWordsmartService(): IWordsmartService;
	getArticleSearchService(): IArticleSearchService;
	getViewerArticleService(): IViewerArticleService;
	getWrittenArticleService(): IWrittenArticleService;
	getNavigationService(): INavigationService;
	getUserService(): IUserService;
	getContentStreampaymentService(): IContentStreamPaymentService;
	getIssueConversionService(): IIssueConversionService;
	getWebsiteUserService(): IWebsiteUserService;
	getWordpressPluginService(): IWordpressPluginService;
	getScheduledTasksService(): IScheduledTaskService;
	getArticleService(): IArticleService;
	getArticleLicenceService(): IArticleLicenceService;
}

export class ParticaServices implements IParticaServices {
	public getArticleLicenceService(): IArticleLicenceService {
		return new ArticleLicenceService() as IArticleLicenceService;
	}
	public getArticleService(): IArticleService {
		return new ArticleService() as IArticleService;
	}
	public getIssueConversionService(): IIssueConversionService {
		return new IssueConversionService() as IIssueConversionService;
	}
	public getWordsmartService(): IWordsmartService {
		return new WordsmartService() as IWordsmartService;
	}
	public getParticaStoreService(): IParticaStoreService {
		return new ParticaStoreService() as IParticaStoreService;
	}
	public getDomainService(): IDomainService {
		return new DomainService() as IDomainService;
	}
	public getIssueService(): IIssueService {
		return new IssueService() as IIssueService;
	}
	public getPdfContentService(): IPdfContentService {
		return new PdfContentService() as IPdfContentService;
	}
	/*public getMetadataService(): IMetadataService {
		return new MetadataService() as IMetadataService;
	}*/
	public getPublicationService(): IPublicationService {
		return new PublicationService() as IPublicationService;
	}
	public getSyndicationArticleService() {
		return new SyndicationArticleService() as ISyndicationArticleService;
	}
	public getViewerContentService(): IViewerContentService {
		return new ViewerContentService() as IViewerContentService;
	}
	public getSectionService(): ISectionService {
		return new SectionService() as ISectionService;
	}
	public getContentStreamService(): IContentStreamService {
		return new ContentStreamService() as IContentStreamService;
	}
	public getContentStreamIssueService(): IContentStreamIssueService {
		return new ContentStreamIssueService() as IContentStreamIssueService;
	}
	public getContentStreamCurateService(): IContentStreamCurateService {
		return new ContentStreamCurateService() as IContentStreamCurateService;
	}
	public getArticleSearchService(): IArticleSearchService {
		return new ArticleSearchService() as IArticleSearchService;
	}
	public getViewerArticleService(): IViewerArticleService {
		return new ViewerArticleService() as IViewerArticleService;
	}
	public getWrittenArticleService(): IWrittenArticleService {
		return new WrittenArticleService() as IWrittenArticleService;
	}
	public getNavigationService(): INavigationService {
		return new NavigationService() as INavigationService;
	}
	public getMetadataService(): IMetadataService {
		return new MetadataService() as IMetadataService;
	}
	public getUserService(): IUserService {
		return new UserService() as IUserService;
	}
	public getContentStreampaymentService(): IContentStreamPaymentService {
		return new ContentStreamPaymentService() as IContentStreamPaymentService;
	}
	public getWebsiteUserService(): IWebsiteUserService {
		return new WebsiteUserService() as IWebsiteUserService;
	}
	public getWordpressPluginService(): IWordpressPluginService {
		return new WordpressPluginService() as IWordpressPluginService;
	}
	public getScheduledTasksService(): IScheduledTaskService {
		return new ScheduledTaskService() as IScheduledTaskService;
	}
}
